/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { useEffect } from 'react';
import { Grid } from '@vds/grids';
import { Title } from '@vds/typography';
import PropTypes from 'prop-types';
import { Line } from '@vds/lines';

import { Body } from '../../../common/Typography/index';
import { getSession, isPreorder, dayAndMonth, isMobile, isWHW, isWHWP2 } from '../../../common/Helpers/index';
import { goToProcessStep } from '../../../../redirection';
import { store } from '../../../../configureStore';
import { Margin, StyledVdsCol, StyledVdsRow } from '../../../common/styles';
import { saveItemToStore, getItemFromStore } from '../../../../utils/sessionStorage';

import Icon from '../../../common/Icon/index';
import { getAddressInfo } from '../../../common/addressUtils';
import '../../../common/Swiper/swiper.css';
import '../../../common/Swiper/index.css';
import { getCurrentFormattedDate } from '../../../common/Helpers/dates';

const ShippingInfo = (props) => {
  useEffect(() => {
    const isCBandFlow = getSession('isCBandFlow');
    if (isCBandFlow && isCBandFlow !== 'Y') {
      props.getPromos();
    }
  }, []);

  const showPaymentOptions = () => {
    if (props.totalDueToday && props.totalDueToday > 0.0) {
      // eslint-disable-next-line react/prop-types
      goToProcessStep(props.currentView.PFS, props.history);
      store.dispatch({ type: 'EDIT_PAYMENT_REVIEW_ORDER' });
      store.dispatch({ type: 'RESET_PAYMENT' });
    }
  };

  const {
    cart5GAddress,
    cartDetails,
    deliverTitle,
    paymentTitle,
    totalDueToday,
    payments,
    paymentDetails,
    shippingAddress,
    storeInfo,
    billingAddress,
  } = props;
  const { shippingDetails } = cartDetails;
  const shippingInfo = shippingDetails?.[0];

  let deliveryDate = shippingInfo?.deliveryDate || getItemFromStore('deliveryDate');
  if (deliveryDate != null && deliveryDate.includes('NaN')) {
    const currDate = getCurrentFormattedDate();
    saveItemToStore('deliveryDate', currDate);
    deliveryDate = currDate;
  }

  const isIspuOpted = props.ISPUOpted;
  const installType = props.setupType;

  let preOrderInServiceDate;
  if (isPreorder()) {
    preOrderInServiceDate = `${cartDetails?.orderDetailsView?.preOrderInServiceDate}T00:00:00`;
    preOrderInServiceDate = preOrderInServiceDate.replace(/-/g, '/').replace(/T.+/, '');
  }

  let shippingAddressDetails;

  if (isIspuOpted && storeInfo) {
    shippingAddressDetails = storeInfo;
  } else if ((installType === 'F' || (isWHW() ||isWHWP2())) && shippingAddress) {
    shippingAddressDetails = shippingAddress;
  } else if (cart5GAddress) {
    shippingAddressDetails = cart5GAddress;
  }

  const objAddressInfo = getAddressInfo(billingAddress, shippingAddressDetails, cart5GAddress, !!isIspuOpted) || {};
  const showBillingAddress = objAddressInfo.isSameBillingService || objAddressInfo.isDifferentAddress || objAddressInfo.isSameShippingService;
  const showServiceAddress = objAddressInfo.isDifferentAddress || objAddressInfo.isSameBillingShipping;

  const showPaymentMethod =
    totalDueToday &&
    (totalDueToday > 0.0 || totalDueToday > 0) &&
    payments &&
    payments.length > 0 &&
    ((payments?.[0].paymentType === 'AC' && cartDetails?.cartHeader?.fullAccountNumber) ||
      payments?.[0]?.creditCardDetails?.cardNumber ||
      (payments?.[0]?.paymentType && payments?.[0]?.paypalPaymentDetails?.paypalPaymentAuthenticateDetails?.paypal_processorUserEmail));

  const showPaymentMethodLine =
    totalDueToday &&
    (totalDueToday > 0.0 || totalDueToday > 0) &&
    paymentDetails &&
    ((paymentDetails?.AC?.acPayment && cartDetails.cartHeader?.fullAccountNumber) ||
      paymentDetails?.CR?.creditCardDetails?.cardNumber ||
      paymentDetails?.PAYPAL?.paypalPaymentDetails?.paypalPaymentAuthenticateDetails?.paypal_processorUserEmail);

  const showDelivery = (installType === 'F' || (isWHW() ||isWHWP2())) && !isIspuOpted;

  return (
    <React.Fragment>
      <Grid className="shippingInfoContainer">
        <StyledVdsRow className="noPadding">
          <StyledVdsCol mTop="42px" className="Chkout" pLeft="0px" colSizes={{ mobile: 4 }}>
            <Title size="large">Checkout</Title>
            {installType !== 'F' ||
              (installType !== 'L' && isMobile() && (
                <Margin top="25px">
                  <Line type="secondary" surface="light" />
                </Margin>
              ))}
          </StyledVdsCol>
        </StyledVdsRow>

        {showDelivery ? (
          <StyledVdsRow className={(isWHW() ||isWHWP2()) || isMobile() ? 'marginTop23 noPadding' : 'marginTop40'} colSizes={{ desktop: 3, tablet: 4, mobile: 1 }}>
            <Body primitive="p" size="small" color="#6F7171">
              {deliverTitle}
            </Body>
          </StyledVdsRow>
        ) : (
          <></>
        )}

        {showDelivery ? (
          <StyledVdsRow mTop="4px" className="noPadding">
            <Body primitive="p" size="medium" className="contains-PII" data-cs-mask>
              {isPreorder() ? dayAndMonth(preOrderInServiceDate) : dayAndMonth(deliveryDate)}
            </Body>
          </StyledVdsRow>
        ) : (
          <></>
        )}

        {showDelivery ? (
          <StyledVdsRow mTop={isMobile ? '24px' : '32px'} className={(isWHW() ||isWHWP2()) || isMobile() ? 'marginTop23 noPadding' : 'marginTop40'}>
            <Line type="secondary" surface="light" />
          </StyledVdsRow>
        ) : (
          <></>
        )}

        <StyledVdsRow
          className={`${
            !isIspuOpted && shippingAddress && !isMobile()
              ? 'marginTop33'
              : !isIspuOpted && shippingAddress && isMobile()
                ? 'noPadding marginTop20 marginRight30'
                : 'marginTop33 noPadding'
          }`}
        >
          {installType === 'F' || installType === 'L' || (isWHW() ||isWHWP2()) ? (
            !isIspuOpted ? (
              <Body color="#6F7171" primitive="div">
                {objAddressInfo.isDifferentAddress || objAddressInfo.isSameBillingService
                  ? objAddressInfo.shippingAddressTitle
                  : objAddressInfo.sameAddressTitle}
              </Body>
            ) : (
              <Body color="#6F7171" primitive="div">
                In-store pickup address
              </Body>
            )
          ) : (
            <Body color="#6F7171" primitive="div">
              {objAddressInfo.isSameAddress ? 'Professional setup address & Billing address' : 'Professional setup address'}
            </Body>
          )}
        </StyledVdsRow>
        <StyledVdsRow className="noPadding" mTop="4px">
          <StyledVdsCol className="noPadding" colSizes={{ mobile: 3, desktop: 6, tablet: 5 }}>
            {objAddressInfo.shippingFullAddress && (
              <Body primitive="span" size="medium" className="contains-PII" data-cs-mask>
                {objAddressInfo.shippingFullAddress}
              </Body>
            )}

            <Margin />
          </StyledVdsCol>
        </StyledVdsRow>
        <StyledVdsRow mTop={isMobile ? '24px' : '32px'} className="noPadding">
          <Line type="secondary" surface="light" />
        </StyledVdsRow>

        {showBillingAddress && objAddressInfo.billingFullAddress ? (
          <StyledVdsRow className={`${!isMobile() ? 'marginTop33' : 'noPadding marginTop20 marginRight30'}`}>
            <Body color="#6F7171" primitive="div">
              {objAddressInfo.isDifferentAddress || objAddressInfo.isSameShippingService
                ? objAddressInfo.billingAddressTitle
                : objAddressInfo.sameAddressTitle}
            </Body>
          </StyledVdsRow>
        ) : (
          <></>
        )}

        {showBillingAddress && objAddressInfo.billingFullAddress ? (
          <StyledVdsRow className="noPadding" mTop="4px">
            <StyledVdsCol className="noPadding" colSizes={{ mobile: 3, desktop: 6, tablet: 5 }}>
              <Body primitive="span" size="medium" className="contains-PII" data-cs-mask>
                {objAddressInfo.billingFullAddress}
              </Body>
              <Margin />
            </StyledVdsCol>
          </StyledVdsRow>
        ) : (
          <></>
        )}

        {showBillingAddress && objAddressInfo.billingFullAddress ? (
          <StyledVdsRow mTop={isMobile ? '24px' : '32px'} className="noPadding">
            <Line type="secondary" surface="light" />
          </StyledVdsRow>
        ) : (
          <></>
        )}

        {showServiceAddress && objAddressInfo.serviceFullAddress ? (
          <StyledVdsRow className={`${!isMobile() ? 'marginTop33' : 'noPadding marginTop20 marginRight30'}`}>
            <Body color="#6F7171" primitive="div">
              {objAddressInfo.serviceAddressTitle}
            </Body>
          </StyledVdsRow>
        ) : (
          <></>
        )}

        {showServiceAddress && objAddressInfo.serviceFullAddress ? (
          <StyledVdsRow className="noPadding" mTop="4px">
            <StyledVdsCol className="noPadding" colSizes={{ mobile: 3, desktop: 6, tablet: 5 }}>
              <Body primitive="span" size="medium" className="contains-PII" data-cs-mask>
                {objAddressInfo.serviceFullAddress}
              </Body>
              <Margin />
            </StyledVdsCol>
          </StyledVdsRow>
        ) : (
          <></>
        )}

        {showServiceAddress && objAddressInfo.serviceFullAddress ? (
          <StyledVdsRow mTop={isMobile ? '24px' : '32px'} className="noPadding">
            <Line type="secondary" surface="light" />
          </StyledVdsRow>
        ) : (
          <></>
        )}

        {showPaymentMethod ? (
          <StyledVdsRow
            colSizes={{ desktop: 3, tablet: 4, mobile: 1 }}
            className={isMobile() ? 'noPadding wordWrap marginTop33' : 'wordWrap marginTop33'}
          >
            <div style={isMobile() && 'noPadding'} className="paymentBox">
              <Body primitive="p" size="small" color="#6F7171">
                {paymentTitle || 'Payment Method'}
              </Body>
              <div style={{ marginTop: '4px' }} className="contains-PII" data-cs-mask>
                {payments?.[0]?.paypalPaymentDetails?.paypalPaymentAuthenticateDetails?.paypal_processorUserEmail ? (
                  <Body primitive="p" size="medium" className="contains-PII" data-cs-mask>
                    {payments?.[0]?.paymentType}
                    <br />
                    {payments?.[0]?.paypalPaymentDetails?.paypalPaymentAuthenticateDetails?.paypal_processorUserEmail}
                  </Body>
                ) : payments?.[0]?.creditCardDetails?.cardNumber ? (
                  <Body primitive="p" size="medium" className="contains-PII" data-cs-mask>
                    {payments?.[0]?.creditCardDetails?.creditCardType ? (payments?.[0]?.creditCardDetails?.creditCardType).toUpperCase() : 'Card'}{' '}
                    ending in {payments?.[0]?.creditCardDetails && payments?.[0]?.creditCardDetails.cardNumber.replace(/\s+/g, '').substr(-4)}
                    <span
                      role="button"
                      onClick={showPaymentOptions}
                      onKeyDown ={(e)=>{
                        if (e.keyCode === 32 || e.keyCode === 13) {showPaymentOptions()}
                      }}
                      style={{ float: 'right' }}
                      tabIndex="0"
                      aria-label="Edit Payment Method"
                      className="paymentEdit"
                    >
                      {totalDueToday && totalDueToday > 0.0 ? <Icon name="right-arrow" size="small" ariaHidden /> : null}
                    </span>
                  </Body>
                ) : (
                  payments?.[0]?.paymentType === 'AC' &&
                  cartDetails?.cartHeader?.fullAccountNumber && (
                    <Body primitive="p" size="medium" className="contains-PII" data-cs-mask>
                      Account ending in <br />
                      XXXX-XXXX-XXXX-000
                      {cartDetails?.cartHeader && cartDetails.cartHeader?.fullAccountNumber.split('-')[1]}
                      <span
                        role="button"
                        onClick={showPaymentOptions}
                        onKeyDown ={(e)=>{
                          if (e.keyCode === 32 || e.keyCode === 13) {showPaymentOptions()}
                        }}
                        style={{ float: 'right' }}
                        tabIndex="0"
                        aria-label="Edit Payment Method"
                        className="paymentEdit"
                      >
                        {totalDueToday && totalDueToday > 0.0 ? <Icon name="right-arrow" size="small" ariaHidden /> : null}
                      </span>
                    </Body>
                  )
                )}
              </div>
            </div>
          </StyledVdsRow>
        ) : (
          <></>
        )}

        {showPaymentMethodLine ? (
          <StyledVdsRow mTop={isMobile ? '24px' : '32px'} className={`${isMobile() ? 'noPadding' : ''}`}>
            <Line type="secondary" surface="light" />
          </StyledVdsRow>
        ) : (
          <></>
        )}
      </Grid>
    </React.Fragment>
  );
};

ShippingInfo.propTypes = {
  cartDetails: PropTypes.object,
  deliverTitle: PropTypes.string,
  paymentTitle: PropTypes.string,
  getPromos: PropTypes.func,
  cart5GAddress: PropTypes.object,
  billingAddress: PropTypes.object,
  shippingAddress: PropTypes.object,
  ISPUOpted: PropTypes.any,
  setupType: PropTypes.string,
  storeInfo: PropTypes.object,
  payments: PropTypes.any,
  totalDueToday: PropTypes.any,
  paymentDetails: PropTypes.object,
  // shippingDescription: PropTypes.object,
};

export default React.memo(ShippingInfo);
